import api from './api';

export const backupService = {
  async list() {
    const res = await api.get('/backups/');
    return res.data;
  },
  async trigger() {
    const res = await api.post('/backups/trigger');
    return res.data;
  },
};
